{{ labelKey | locLabel | capitalize }}
<mat-icon [class.fulfilled]="fulfilled"> {{ fulfilled ? 'done' : 'not_interested' }}</mat-icon>
